import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translations
import en from './locales/en/translation.json';
import es from './locales/es/translation.json';
import ar from './locales/ar/translation.json';
import it from './locales/it/translation.json';
import fr from './locales/fr/translation.json';
import pt from './locales/pt/translation.json';
import de from './locales/de/translation.json';
import hi from './locales/hi/translation.json';
import ja from './locales/ja/translation.json';
import ko from './locales/ko/translation.json';

// Language configuration with native names
export const languages = [
  { code: 'en', name: 'English', nativeName: 'English', dir: 'ltr' },
  { code: 'es', name: 'Spanish', nativeName: 'Español', dir: 'ltr' },
  { code: 'ar', name: 'Arabic', nativeName: 'العربية', dir: 'rtl' },
  { code: 'it', name: 'Italian', nativeName: 'Italiano', dir: 'ltr' },
  { code: 'fr', name: 'French', nativeName: 'Français', dir: 'ltr' },
  { code: 'pt', name: 'Portuguese', nativeName: 'Português', dir: 'ltr' },
  { code: 'de', name: 'German', nativeName: 'Deutsch', dir: 'ltr' },
  { code: 'hi', name: 'Hindi', nativeName: 'हिन्दी', dir: 'ltr' },
  { code: 'ja', name: 'Japanese', nativeName: '日本語', dir: 'ltr' },
  { code: 'ko', name: 'Korean', nativeName: '한국어', dir: 'ltr' }
];

const resources = {
  en: { translation: en },
  es: { translation: es },
  ar: { translation: ar },
  it: { translation: it },
  fr: { translation: fr },
  pt: { translation: pt },
  de: { translation: de },
  hi: { translation: hi },
  ja: { translation: ja },
  ko: { translation: ko }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'pb_language'
    },

    interpolation: {
      escapeValue: false // React already handles XSS
    },

    react: {
      useSuspense: false
    }
  });

// Function to change language and update document direction
export const changeLanguage = (langCode) => {
  const lang = languages.find(l => l.code === langCode);
  if (lang) {
    i18n.changeLanguage(langCode);
    document.documentElement.dir = lang.dir;
    document.documentElement.lang = langCode;
    localStorage.setItem('pb_language', langCode);
  }
};

// Initialize document direction on load
const currentLang = languages.find(l => l.code === i18n.language) || languages[0];
document.documentElement.dir = currentLang.dir;
document.documentElement.lang = currentLang.code;

export default i18n;
